import { Component, ChangeDetectionStrategy } from '@angular/core';

/** Deux feuilles superposées : « Copier ». Hérite de la couleur du texte et remplit son hôte. */
@Component({
  selector: 'vw-copy-icon',
  imports: [],
  host: { class: 'inline-block h-6 w-6' },
  changeDetection: ChangeDetectionStrategy.Eager,
  template: `<svg width="100%" height="100%" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
    <rect x="9" y="9" width="12" height="12" rx="2" stroke="currentColor" stroke-width="2" stroke-linejoin="round"/>
    <path d="M5 15H4C3.44772 15 3 14.5523 3 14V4C3 3.44772 3.44772 3 4 3H14C14.5523 3 15 3.44772 15 4V5" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
  </svg>`,
})
export class CopyIconComponent {}
